var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"white--text",attrs:{"app":"","color":"primary"}},[(_vm.checkMode)?_c('div',{staticClass:"caption"},[_c('v-icon',{staticClass:"caption",attrs:{"color":"white"}},[_vm._v("code")]),_vm._v(" In development! ")],1):_vm._e(),_c('v-spacer'),_c('span',{staticClass:"caption"},[_vm._v("© "+_vm._s(_vm.currentYear))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }